<script>
export default {
	props: [
		'buttonName',
	],
	data() {
		return {
			previewFileLabel: 'Vælg fil...',
		};
	},
	methods: {
		changePreviewFiles(el) {
			const value = el.target.value
				.split('\\')
				.pop();

			this.$refs.previewFileLabel.classList.remove('untouched');

			this.previewFileLabel = value;
		},
	},
};
</script>

<template src="./SkyInputFile.html"></template>
<style src="./SkyInputFile.scss"></style>



// WEBPACK FOOTER //
// SkyInputFile.vue?f8591fb2